<label
  class="p-m-0 p-p-0 p-d-block"
  style="font-size: 1.25rem; word-break: break-word"
>
  {{ to?.label ?? '' | dictionary }}
</label>
